module.exports = __webpack_public_path__ + "img/AboutUs.2bfa12a4.svg";